"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrelineDebtCalculationMethod = void 0;
/** @TranslateToPython **/
var PrelineDebtCalculationMethod;
(function (PrelineDebtCalculationMethod) {
    PrelineDebtCalculationMethod["DEFAULT"] = "DEFAULT";
    PrelineDebtCalculationMethod["EXPERIAN_PREMIER"] = "EXPERIAN_PREMIER";
    PrelineDebtCalculationMethod["EXPERIAN_TRADELINE"] = "EXPERIAN_TRADELINE";
})(PrelineDebtCalculationMethod || (exports.PrelineDebtCalculationMethod = PrelineDebtCalculationMethod = {}));
